import Quote, { QuoteDto } from "./Quote"
import HttpClient from "../helpers/HttpClient"
import { HttpError, isError } from "../helpers/Error"

class QuoteService {
    httpClient: HttpClient<Quote, QuoteDto> = new HttpClient<Quote, QuoteDto>(Quote)

    async get(id: string): Promise<Quote | HttpError> {
        const res = await this.httpClient.get(`/quotes/${id}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Quote
    }

    async applyBulkDiscount(id: string, payload: object) {
        return this.httpClient.put(`/quotes/${id}/bulk-discount`, payload)
    }

    async applyBulkUpdate(id: string, payload: object) {
        return this.httpClient.patch(`/quotes/${id}/bulk-update`, payload)
    }

    async fetchQuoteById(quoteId: string){
        return await this.httpClient.get(`/quotes/${quoteId}`)
    }
}
const instance = new QuoteService()
export default instance


// WEBPACK FOOTER //
// ./src/state/quote/QuoteService.ts